export { default } from "./Icon.deprecated";
export type { IconName, IconSize } from "./Icon.deprecated";
export { isIconVariant } from "./Icon.deprecated";
